import { Route } from 'react-router-dom';
import { KpiMetricsPage } from './pages/KpiMetricsPage.js';
import { KpiTypesPage } from './pages/KpiTypesPage.js';

/**
 * KPI — license-level metric tables. Two pages (metrics, types)
 * matching the legacy slice layout. Both read through the
 * engine-proxy.
 */
export function kpiRoutes(): JSX.Element {
  return (
    <>
      <Route path="/kpi" element={<KpiMetricsPage />} />
      <Route path="/kpi/types" element={<KpiTypesPage />} />
    </>
  );
}
